import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getCriteriaRatingUgoAvailableColumns } from './api';

export const path = '/criteria-rating-ugo/list';

const PageCriteriaRatingUgoList: React.FC = (props) => {
  const CriteriaRatingUgoList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getCriteriaRatingUgoAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <CriteriaRatingUgoList {...props} />;
};

export default PageCriteriaRatingUgoList;
